import React, { useState, useEffect } from 'react'
import makeHospitalAddCollaborator from 'main/factories/pages/hospital/add-collaborator/hospital-add-collaborator-factory'
import makeHospitalAddSurgicalOrder from 'main/factories/pages/hospital/add-surgical-order/hospital-add-surgical-order-factory'
import makeAddDoctor from 'main/factories/pages/hospital/hospital-add-doctor-factory'
import makeHospitalLogin from 'main/factories/pages/hospital/hospital-login-factory'
import makeHospitalPasswordRecovery from 'main/factories/pages/hospital/hospital-password-recovery-factory'
import { useStores } from 'presentation/hooks/use-stores'
import {
  BrowserRouter,
  Switch,
  Route,
  Redirect,
  useLocation,
  withRouter
} from 'react-router-dom'
import makeHospitalPainAlerts from 'main/factories/pages/hospital/pain-alerts/hospital-pain-alerts-factory'
import makeHospitalDoctors from 'main/factories/pages/hospital/doctors/hospital-doctors-factory'
import makeHospitalSignup from 'main/factories/pages/hospital/signup/hospital-signup-factory'
import makeHospitalAuthorization from 'main/factories/pages/hospital/authorization/hospital-authorization-factory'
import PatientInfo from 'presentation/secretary/pages/PatientInfo'
import ProcedureInfo from 'presentation/secretary/pages/ProcedureInfo'
import HospitalPrivateRoute from 'presentation/shared/components/HospitalPrivateRoute'
import { Profile } from 'common/enum/profile'
import makeHospitalPatients from 'main/factories/pages/hospital/patients/hospital-patients-factory'
import makeHospitalOrderAbstract from 'main/factories/pages/hospital/order-abstract/hospital-order-abstract-factory'
import { AddPatient } from 'presentation/hospital/pages/AddPatient'
import CanceledOrderInfo from 'presentation/hospital/pages/CanceledOrderInfo'
import HospitalProfile from 'presentation/hospital/pages/Profile'
import AmbulatoryScheduleLayout from 'presentation/hospital/layouts/AmbulatoryScheduleResume'
import AmbulatoryScheduleDetails from 'presentation/hospital/layouts/AmbulatoryScheduleDetails'
import makeHospitalHome from 'main/factories/pages/hospital/hospital-home-factory'
import Solicitation from 'presentation/hospital/pages/Solicitation'
import makeHospitalCollaboratorsFactory from 'main/factories/pages/hospital/collaborators/hospital-collaborators-factory'
import NewRegistrationsDetails from 'presentation/hospital/pages/DoctorRegister/NewRegistrationsDetails'
import EmergencyRoomDetails from 'presentation/hospital/pages/EmergencyRoomDetails'
import FinishOrderLayout from 'presentation/hospital/layouts/FinishOrder'
import CreatePendency from 'presentation/hospital/pages/CreatePendency'
import UserTerms from 'presentation/shared/pages/UserTerms'
import HospitalScheduleSurgeryRequests from 'presentation/hospital/pages/Home/SchedulingSector/ScheduleSurgeryRequests'
import HospitalScheduledSurgeries from 'presentation/hospital/pages/Home/SchedulingSector/ScheduledSurgeries'
import HospitalCancelledScheduledSurgeryRequests from 'presentation/hospital/pages/Home/SchedulingSector/CancelledRequestSchedules'
import SurgicalOrder from 'presentation/hospital/pages/SurgicalOrder'
import OrderManagement from 'presentation/hospital/pages/OrderManagement'
import SolicitationCancelOrder from 'presentation/hospital/pages/SolicitationCancelOrder'
// import SurgicalOrdersStatus from 'presentation/hospital/pages/SurgicalOrdersStatus'
import ActiveSearchDetails from 'presentation/hospital/pages/ActiveSearchDetails'
import ActiveSearchDashboard from 'presentation/hospital/pages/ActiveSearchDashboard'
import SchedulingSectorAllOrders from 'presentation/hospital/pages/Home/SchedulingSector/AllOrders'
// import SchedulingSectorCreateScheduleOrders from 'presentation/hospital/pages/Home/SchedulingSector/CreateScheduleOrders'
import SolicitationCreateSurgicalSchedule from 'presentation/hospital/pages/Home/SchedulingSector/SolicitationCreateSurgicalSchedule'
// import CreateSurgicalSchedule from 'presentation/hospital/pages/Home/SchedulingSector/CreateSurgicalSchedule'
// import CalendarTests from 'presentation/hospital/pages/Home/SchedulingSector/CalendarTests'
// import DataGridExamples from 'presentation/hospital/pages/DataGridExamples'

export const ScrollToTop = withRouter(() => {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
})

const SwitchRouter = withRouter(() => {
  const { pathname } = useLocation()
  const stores = useStores()
  const currentUser = stores.currentAccount
  const [pendingTerms, setPendingTerms] = useState<boolean>(false)

  const isPendingTerms = currentUser
    .getCurrentAccount()
    ?.user?.terms?.some((term) => term.signed === false)

  const pendingTermsOfUse = () =>
    currentUser.getCurrentAccount()?.accessToken && isPendingTerms

  useEffect(() => {
    setPendingTerms(!!pendingTermsOfUse())
  }, [pathname])

  return (
    <>
      {pendingTerms ? (
        <Switch>
          <HospitalPrivateRoute
            path="/termos-de-uso"
            exact
            component={UserTerms}
            profile={[
              Profile.CRMO,
              Profile.HOSPITAL,
              Profile.HOSPITALIZATION,
              Profile.AMBULATORY,
              Profile.ONCOLOGY,
              Profile.DOCTOR_REGISTER,
              Profile.DIRECTOR_DOCTOR_REGISTER,
              Profile.ADMIN_SECTORIAL_CRMO,
              Profile.EMERGENCY_ROOM
            ]}
          />

          <Route
            path="/*"
            component={() => {
              return (
                <>
                  <Redirect to="/termos-de-uso" />
                </>
              )
            }}
          />
        </Switch>
      ) : (
        <Switch>
          <Route
            path="/"
            exact
            component={() => {
              return (
                <>
                  <Redirect
                    to={
                      currentUser.getCurrentAccount()?.accessToken
                        ? '/home'
                        : '/login'
                    }
                  />
                </>
              )
            }}
          />
          <Route path="/login" exact component={makeHospitalLogin} />
          <Route path="/cadastro/:hash" exact component={makeHospitalSignup} />
          <HospitalPrivateRoute
            path="/home"
            exact
            component={makeHospitalHome}
            profile={[
              Profile.CRMO,
              Profile.HOSPITAL,
              Profile.HOSPITALIZATION,
              Profile.AMBULATORY,
              Profile.ONCOLOGY,
              Profile.DOCTOR_REGISTER,
              Profile.DIRECTOR_DOCTOR_REGISTER,
              Profile.ADMIN_SECTORIAL_CRMO,
              Profile.EMERGENCY_ROOM
            ]}
          />
          <HospitalPrivateRoute
            path="/medicos/save"
            exact
            component={makeAddDoctor}
            profile={[Profile.CRMO, Profile.HOSPITAL]}
          />
          <HospitalPrivateRoute
            path="/colaboradores"
            exact
            component={makeHospitalCollaboratorsFactory}
            profile={[Profile.HOSPITAL]}
          />
          <HospitalPrivateRoute
            path="/colaboradores/save"
            exact
            component={makeHospitalAddCollaborator}
            profile={[Profile.HOSPITAL]}
          />
          <Route
            path="/recuperar-senha/:type"
            exact
            component={makeHospitalPasswordRecovery}
          />
          <HospitalPrivateRoute
            path="/alertas/"
            exact
            component={makeHospitalPainAlerts}
            profile={[Profile.HOSPITALIZATION, Profile.CRMO]}
          />
          <HospitalPrivateRoute
            path="/pedido/novo"
            exact
            component={makeHospitalAddSurgicalOrder}
            profile={[Profile.CRMO]}
          />
          <HospitalPrivateRoute
            path="/medicos"
            exact
            component={makeHospitalDoctors}
            profile={[Profile.CRMO, Profile.HOSPITAL]}
          />
          {/* New pedidos datagrid in development... (Deprecated) */}
          {/* <HospitalPrivateRoute
            path="/pedidos-new/:status"
            exact
            component={SurgicalOrdersStatus}
            profile={[Profile.CRMO, Profile.HOSPITAL]}
          /> */}
          <HospitalPrivateRoute
            path="/pedidos/:status"
            exact
            component={makeHospitalAuthorization}
            profile={[Profile.CRMO, Profile.HOSPITAL]}
          />
          <HospitalPrivateRoute
            path="/paciente"
            exact
            component={PatientInfo}
            profile={[Profile.CRMO, Profile.HOSPITAL]}
          />
          <HospitalPrivateRoute
            path="/gestao-pedidos"
            exact
            component={OrderManagement}
            profile={[Profile.CRMO, Profile.HOSPITAL]}
          />
          <HospitalPrivateRoute
            path="/paciente/save"
            exact
            component={AddPatient}
            profile={[Profile.HOSPITAL]}
          />
          <HospitalPrivateRoute
            path="/pacientes"
            exact
            component={makeHospitalPatients}
            profile={[Profile.CRMO, Profile.HOSPITAL]}
          />
          <HospitalPrivateRoute
            path="/procedimento"
            exact
            component={ProcedureInfo}
            profile={[Profile.CRMO, Profile.HOSPITAL]}
          />
          <HospitalPrivateRoute
            path="/pedido"
            exact
            component={SurgicalOrder}
            profile={[Profile.CRMO, Profile.HOSPITAL]}
          />
          <HospitalPrivateRoute
            path="/pedido/resumo"
            exact
            component={makeHospitalOrderAbstract}
            profile={[Profile.CRMO, Profile.HOSPITAL]}
          />
          <HospitalPrivateRoute
            path="/pedido/gerar-pendencia"
            exact
            component={CreatePendency}
            profile={[Profile.CRMO, Profile.HOSPITAL]}
          />
          <HospitalPrivateRoute
            path="/pedido/finalizar"
            exact
            component={FinishOrderLayout}
            profile={[Profile.CRMO, Profile.HOSPITAL]}
          />
          <HospitalPrivateRoute
            path="/pedido-cancelado/resumo"
            exact
            component={CanceledOrderInfo}
            profile={[Profile.CRMO, Profile.HOSPITAL]}
          />
          <HospitalPrivateRoute
            path="/pedido/solicitacao-cancelamento"
            exact
            component={SolicitationCancelOrder}
            profile={[Profile.CRMO, Profile.HOSPITAL]}
          />
          <HospitalPrivateRoute
            path="/solicitacao/resumo"
            exact
            component={Solicitation}
            profile={[Profile.CRMO, Profile.HOSPITAL]}
          />
          <HospitalPrivateRoute
            path="/perfil/:id"
            profile={[Profile.CRMO, Profile.HOSPITALIZATION, Profile.HOSPITAL]}
            exact
            component={HospitalProfile}
          />
          <HospitalPrivateRoute
            path="/agendamento"
            exact
            component={AmbulatoryScheduleLayout}
            profile={[Profile.AMBULATORY]}
          />
          <HospitalPrivateRoute
            path="/agendamento/detalhes"
            exact
            component={AmbulatoryScheduleDetails}
            profile={[Profile.AMBULATORY]}
          />
          <HospitalPrivateRoute
            path="/novos-cadastros/detalhes"
            exact
            component={NewRegistrationsDetails}
            profile={[
              Profile.DOCTOR_REGISTER,
              Profile.DIRECTOR_DOCTOR_REGISTER
            ]}
          />
          <HospitalPrivateRoute
            path="/pronto-socorro/paciente"
            exact
            component={EmergencyRoomDetails}
            profile={[Profile.EMERGENCY_ROOM]}
          />

          <HospitalPrivateRoute
            path="/busca-ativa"
            exact
            component={ActiveSearchDashboard}
            profile={[Profile.HOSPITAL, Profile.CRMO]}
          />

          <HospitalPrivateRoute
            path="/busca-ativa/detalhes"
            exact
            component={ActiveSearchDetails}
            profile={[Profile.HOSPITAL, Profile.CRMO]}
          />

          <HospitalPrivateRoute
            path="/setor-de-marcacao/pedidos/todos"
            exact
            component={SchedulingSectorAllOrders}
            profile={[Profile.CRMO, Profile.HOSPITAL]}
          />

          {/* Funcionalidade temporariamente desativada (aguardando validação do cliente) */}
          {/* <HospitalPrivateRoute
            path="/setor-de-marcacao/pedidos/criar-agendamento"
            exact
            component={SchedulingSectorCreateScheduleOrders}
            profile={[Profile.CRMO, Profile.HOSPITAL]}
          />

          <HospitalPrivateRoute
            path="/setor-de-marcacao/agendar"
            exact
            component={CreateSurgicalSchedule}
            profile={[Profile.SETOR_DE_MARCACAO, Profile.HOSPITAL]}
          /> */}

          <HospitalPrivateRoute
            path="/setor-de-marcacao/solicitacoes"
            exact
            component={HospitalScheduleSurgeryRequests}
            profile={[Profile.SETOR_DE_MARCACAO, Profile.HOSPITAL]}
          />

          <HospitalPrivateRoute
            path="/setor-de-marcacao/agendar-solicitacao"
            exact
            component={SolicitationCreateSurgicalSchedule}
            profile={[Profile.SETOR_DE_MARCACAO, Profile.HOSPITAL]}
          />

          <HospitalPrivateRoute
            path="/setor-de-marcacao/cirurgias-agendadas"
            exact
            component={HospitalScheduledSurgeries}
            profile={[Profile.SETOR_DE_MARCACAO, Profile.HOSPITAL]}
          />

          <HospitalPrivateRoute
            path="/setor-de-marcacao/agendamentos-cancelados"
            exact
            component={HospitalCancelledScheduledSurgeryRequests}
            profile={[Profile.SETOR_DE_MARCACAO, Profile.HOSPITAL]}
          />

          {/* Test only */}
          {/* <Route path="/calendar-tests" exact component={CalendarTests} /> */}

          {/* Test only */}
          {/* <HospitalPrivateRoute
            path="/datagrid-examples"
            exact
            component={DataGridExamples}
            profile={[
              Profile.CRMO,
              Profile.SETOR_DE_MARCACAO,
              Profile.HOSPITAL
            ]}
          /> */}

          <Route path="/*" component={() => <Redirect to="/" />} />
        </Switch>
      )}
    </>
  )
})

const HospitalRoutes = () => {
  return (
    <BrowserRouter
      basename={process.env.NODE_ENV === 'development' ? '/hospital' : ''}
    >
      <ScrollToTop />
      <SwitchRouter />
    </BrowserRouter>
  )
}

export default HospitalRoutes
